import React, { Component } from 'react'
import translate from '@/i18n/translate'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import classNames from '@/helpers/classNames'
import { Block } from '@/ui/Blocks'
import AddIcon from '@/media/svg/icon-add.svg'

const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? 'lightblue' : '',
})
const getItemStyle = (draggableStyle, isDragging) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',

  // styles we need to apply on draggables
  ...draggableStyle,
})

class buildLayout extends Component {
  render() {
    const {
      theme,
      items,
      addNew,
      newsletterId,
      onChange,
      onDragEnd,
      onDragStart,
      onSelect,
      selected,
      duplicateBlock,
      removeBlock,
    } = this.props

    if (items.length === 0) {
      return (
        <div>
          <div className={classNames(theme, 'card', 'block-card')}>
            <div className={classNames(theme, 'card-body', 'with-header')}>
              <div
                className={classNames(theme, 'card-content', 'text-center')}
                onClick={e => addNew()}
                style={{ cursor: 'pointer' }}
              >
                <AddIcon fill="currentColor" width="70" height="70" className={theme['add-icon']} />
                <div>Start by adding the first contenct block</div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    // {...provided.dragHandleProps } <- ovo ide u block-wraper ispod style
    return (
      <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
              {items.map(item => (
                <Draggable key={item.id} draggableId={item.id}>
                  {(provided, snapshot) => {
                    // Patched onMouseDown, make inputs selectable
                    const onMouseDown = event => {
                      if (event.target.nodeName !== 'INPUT') {
                        provided.dragHandleProps.onMouseDown(event)
                      }
                    }
                    // Patched onKeyDown handler, make typing in inputs
                    // work as expected. For example, spacebar can be used
                    // as normal characters instead of a shortcut.
                    const onKeyDown = event => {
                      if (event.target.nodeName !== 'INPUT') {
                        provided.dragHandleProps.onKeyDown(event)
                      }
                    }
                    // patching drag handle props
                    const patched = {
                      ...provided.dragHandleProps,
                      onMouseDown,
                      onKeyDown,
                    }
                    return (
                      <div>
                        <div
                          ref={provided.innerRef}
                          className={classNames(theme, 'block-wraper')}
                          style={getItemStyle(provided.draggableStyle, snapshot.isDragging)}
                        >
                          <Block
                            item={item}
                            active={selected && item && selected.id === item.id}
                            header={item.header}
                            onChange={onChange}
                            onRemove={removeBlock}
                            onDuplicate={duplicateBlock}
                            onClick={onSelect}
                            newsletterId={newsletterId}
                            theme={theme}
                            handle={patched}
                          />
                        </div>
                        {provided.placeholder}
                      </div>
                    )
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}

export default translate(buildLayout)



// WEBPACK FOOTER //
// ./view/Dashboard/buildLayout.js